/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/search': {
    width: 303,
    height: 303,
    viewBox: '0 0 303 303',
    data: '<rect pid="0" width="303" height="303" rx="8" _fill="#E9EEF9"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M85.646 84.646c-27.528 27.528-27.528 72.32 0 99.848 23.354 23.354 58.087 26.891 85.21 10.621 0 0 1.96-1.169 3.614.485l35.946 35.946c7.169 7.17 17.195 8.876 23.553 2.517l1.095-1.094c6.358-6.359 4.651-16.384-2.519-23.553l-36.021-36.022c-1.579-1.577-.41-3.538-.41-3.538 16.271-27.123 12.734-61.856-10.62-85.21-27.528-27.528-72.32-27.528-99.848 0zm86.808 13.04c20.341 20.34 20.341 53.436.001 73.776-20.342 20.34-53.437 20.34-73.778 0-20.34-20.34-20.34-53.437 0-73.777 20.34-20.34 53.436-20.34 73.777 0z" _fill="#614789"/>'
  }
})
